import {
    AlipayCircleOutline,
    ApartmentOutline,
    ApiOutline,
    AppstoreAddOutline,
    AppstoreOutline,
    ArrowDownOutline,
    ArrowLeftOutline,
    ArrowRightOutline,
    AuditOutline,
    BarChartOutline,
    BookOutline,
    BorderLeftOutline,
    BorderRightOutline,
    CloudOutline,
    CommentOutline,
    ContainerOutline,
    ControlOutline,
    CopyrightOutline,
    CustomerServiceOutline,
    DashboardOutline,
    DatabaseFill,
    DatabaseOutline,
    DeleteFill,
    DeleteOutline,
    DesktopOutline,
    DingdingOutline,
    DislikeOutline,
    DownloadOutline,
    ExpandOutline,
    EyeOutline,
    FileAddOutline,
    FileProtectOutline,
    FileTextOutline,
    FilterOutline,
    FolderAddOutline,
    FolderOpenOutline,
    FolderOutline,
    ForkOutline,
    FrownOutline,
    FullscreenExitOutline,
    FullscreenOutline,
    FundViewOutline,
    GithubOutline,
    GlobalOutline,
    GroupOutline,
    HddOutline,
    HighlightOutline,
    HomeOutline,
    InsertRowBelowOutline,
    IssuesCloseOutline,
    LaptopOutline,
    LayoutOutline,
    LeftCircleOutline,
    LikeOutline,
    LockOutline,
    LogoutOutline,
    MailOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    MessageFill,
    MessageOutline,
    MinusCircleOutline,
    MinusOutline,
    MoreOutline,
    PayCircleOutline,
    PieChartOutline,
    PlusCircleOutline,
    PlusOutline,
    PrinterOutline,
    PullRequestOutline,
    QuestionCircleTwoTone,
    RadarChartOutline,
    RedoOutline,
    RightCircleOutline,
    RocketOutline,
    SafetyCertificateOutline,
    ScanOutline,
    ScheduleOutline,
    SelectOutline,
    SettingFill,
    SettingOutline,
    ShareAltOutline,
    ShoppingCartOutline,
    SisternodeOutline,
    SlidersOutline,
    SnippetsOutline,
    SolutionOutline,
    SoundOutline,
    StarOutline,
    SyncOutline,
    TaobaoCircleOutline,
    TaobaoOutline,
    TeamOutline,
    ToolOutline,
    TrophyOutline,
    UndoOutline,
    UnorderedListOutline,
    UsbOutline,
    UserAddOutline,
    UsergroupAddOutline,
    UsergroupDeleteOutline,
    UserOutline,
    WeiboCircleOutline,
    WifiOutline
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
    AlipayCircleOutline,
    ApiOutline,
    AppstoreOutline,
    ArrowDownOutline,
    ApartmentOutline,
    BookOutline,
    BorderLeftOutline,
    BorderRightOutline,
    CloudOutline,
    CopyrightOutline,
    CustomerServiceOutline,
    DashboardOutline,
    DatabaseOutline,
    DingdingOutline,
    DislikeOutline,
    DownloadOutline,
    ForkOutline,
    FrownOutline,
    FullscreenExitOutline,
    FullscreenOutline,
    GithubOutline,
    GlobalOutline,
    HddOutline,
    LaptopOutline,
    LikeOutline,
    LockOutline,
    LogoutOutline,
    MailOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    MessageOutline,
    MessageFill,
    PayCircleOutline,
    PieChartOutline,
    PrinterOutline,
    RocketOutline,
    ScanOutline,
    SettingOutline,
    ShareAltOutline,
    ShoppingCartOutline,
    SoundOutline,
    StarOutline,
    TaobaoCircleOutline,
    TaobaoOutline,
    TeamOutline,
    ToolOutline,
    TrophyOutline,
    UsbOutline,
    UserOutline,
    WeiboCircleOutline,
    SlidersOutline,
    SnippetsOutline,
    WifiOutline,
    DesktopOutline,
    HomeOutline,
    HighlightOutline,
    BarChartOutline,
    UserAddOutline,
    DatabaseFill,
    UsergroupAddOutline,
    UsergroupDeleteOutline,
    InsertRowBelowOutline,
    IssuesCloseOutline,
    SelectOutline,
    DeleteFill,
    SyncOutline,
    MinusOutline,
    FolderOpenOutline,
    ControlOutline,
    SolutionOutline,
    AuditOutline,
    SafetyCertificateOutline,
    PlusOutline,
    DeleteOutline,
    AppstoreAddOutline,
    MinusCircleOutline,
    PlusCircleOutline,
    RadarChartOutline,
    ContainerOutline,
    SettingFill,
    MoreOutline,
    ArrowLeftOutline,
    GroupOutline,
    FileProtectOutline,
    FileTextOutline,
    ScheduleOutline,
    QuestionCircleTwoTone,
    PullRequestOutline,
    FilterOutline,
    LeftCircleOutline,
    RightCircleOutline,
    EyeOutline,
    ArrowRightOutline,
    FolderOutline,
    FolderAddOutline,
    FileAddOutline,
    ExpandOutline,
    RedoOutline,
    UndoOutline,
    LayoutOutline,
    CommentOutline,
    SisternodeOutline,
    UnorderedListOutline,
    FundViewOutline
];
